module.exports = __webpack_public_path__ + "/a2a1ba89e7f9d29f7d5aee76e8b9f7ab.woff";